var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUltrasonicMotionSensor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.2,13.9 0.5,13.9 0.5,3.9 3.2,3.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.1,3.9C2.5,5.7,2.3,7.6,2.4,9.5c0,1.5,0.3,2.9,0.7,4.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 7,
    x2: 4.9,
    y2: 5.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.4,
    y1: 5.1,
    x2: 9.7,
    y2: 3.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.3,
    y1: 2.7,
    x2: 15.5,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 10.7,
    x2: 4.9,
    y2: 11.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.7,
    y1: 11.9,
    x2: 9.1,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.4,
    y1: 13.9,
    x2: 14.9,
    y2: 15.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltrasonicMotionSensor);
export default __webpack_public_path__ + "static/media/UltrasonicMotionSensor.1803e73cd883ac74e671b9133ca40bad.svg";
export { ForwardRef as ReactComponent };